webpackJsonp([114276838955818,60335399758886],{

/***/ 113:
/***/ (function(module, exports) {

	module.exports = {"layoutContext":{}}

/***/ }),

/***/ 207:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(216);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(113);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 211:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n    maxWidth: 800;\n"], ["\n    maxWidth: 800;\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(7);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var StyledContainer = _styledComponents2.default.div(_templateObject);
	
	var CardWrapper = function CardWrapper(props) {
	    return _react2.default.createElement(
	        StyledContainer,
	        null,
	        props.children
	    );
	};
	
	exports.default = CardWrapper;
	module.exports = exports["default"];

/***/ }),

/***/ 215:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n    padding: 4em;\n"], ["\n    padding: 4em;\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n   margin: 1rem auto;\n   maxWidth: 800px;\n"], ["\n   margin: 1rem auto;\n   maxWidth: 800px;\n"]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n   list-style-type: none;\n"], ["\n   list-style-type: none;\n"]),
	    _templateObject4 = _taggedTemplateLiteralLoose(["\n  height: 100%;\n  width: 40%;\n"], ["\n  height: 100%;\n  width: 40%;\n"]),
	    _templateObject5 = _taggedTemplateLiteralLoose(["\n  padding-right: 5px;\n"], ["\n  padding-right: 5px;\n"]),
	    _templateObject6 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(7);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Wrapper = _styledComponents2.default.section(_templateObject);
	
	var StyledFooterDiv = _styledComponents2.default.div(_templateObject2);
	
	var ListWithoutBullet = _styledComponents2.default.ul(_templateObject3);
	
	var SizedImage = _styledComponents2.default.img(_templateObject4);
	
	var PaddedLink = _styledComponents2.default.a(_templateObject5);
	
	var StyledListItem = _styledComponents2.default.li(_templateObject6);
	
	exports.default = function () {
	  return _react2.default.createElement(
	    Wrapper,
	    null,
	    _react2.default.createElement(
	      StyledFooterDiv,
	      null,
	      _react2.default.createElement(
	        ListWithoutBullet,
	        null,
	        _react2.default.createElement(
	          StyledListItem,
	          null,
	          _react2.default.createElement(
	            PaddedLink,
	            { href: "https://www.github.com/gemcfadyen" },
	            _react2.default.createElement(SizedImage, { src: "https://pennyprojects.co.uk/github.jpeg", alt: "github logo" })
	          ),
	          _react2.default.createElement(
	            PaddedLink,
	            { href: "https://www.twitter.com/gemcfadyen" },
	            _react2.default.createElement(SizedImage, { src: "https://pennyprojects.co.uk/twitter.jpeg", alt: "twitterlogo" })
	          ),
	          _react2.default.createElement(
	            PaddedLink,
	            { href: "https://www.linkedin.com/in/georgina-m-03942b104" },
	            _react2.default.createElement(SizedImage, { src: "https://pennyprojects.co.uk/linkedin.jpeg", alt: "linkedin logo" })
	          )
	        )
	      )
	    )
	  );
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 216:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  margin: 0 auto;\n  max-width: 900px;\n"], ["\n  margin: 0 auto;\n  max-width: 900px;\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  padding: 1.25rem 1rem;\n  background: lightBlue;\n  box-shadow: inset 0 0 0 2px darkBlue;\n"], ["\n  padding: 1.25rem 1rem;\n  background: lightBlue;\n  box-shadow: inset 0 0 0 2px darkBlue;\n"]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n  listStyle: none;\n  float: right;\n  display: flex;\n"], ["\n  listStyle: none;\n  float: right;\n  display: flex;\n"]),
	    _templateObject4 = _taggedTemplateLiteralLoose(["\n marginBottom: 1.5rem;\n"], ["\n marginBottom: 1.5rem;\n"]),
	    _templateObject5 = _taggedTemplateLiteralLoose(["\n  textShadow: none;\n  backgroundImage: none;\n  color: midnightblue;\n  font-weight: bold;\n\n   &:hover {\n    color: white;\n"], ["\n  textShadow: none;\n  backgroundImage: none;\n  color: midnightblue;\n  font-weight: bold;\n\n   &:hover {\n    color: white;\n"]),
	    _templateObject6 = _taggedTemplateLiteralLoose(["\n  display: inline;\n"], ["\n  display: inline;\n"]),
	    _templateObject7 = _taggedTemplateLiteralLoose(["\n  display: inline-block;\n  margin-right: 1rem;\n"], ["\n  display: inline-block;\n  margin-right: 1rem;\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(75);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _footer = __webpack_require__(215);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _styledComponents = __webpack_require__(7);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _CardWrapper = __webpack_require__(211);
	
	var _CardWrapper2 = _interopRequireDefault(_CardWrapper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Gutter = _styledComponents2.default.div(_templateObject);
	
	var PageStyleForWholeSite = _styledComponents2.default.div(_templateObject2);
	
	var StyledList = _styledComponents2.default.ul(_templateObject3);
	
	var StyledHeader = _styledComponents2.default.header(_templateObject4);
	
	var StyledLink = (0, _styledComponents2.default)(_gatsbyLink2.default)(_templateObject5);
	
	var InlineHeader = _styledComponents2.default.h3(_templateObject6);
	
	var StyledListElement = _styledComponents2.default.li(_templateObject7);
	
	var ListLink = function ListLink(props) {
	  return _react2.default.createElement(
	    StyledListElement,
	    null,
	    _react2.default.createElement(
	      StyledLink,
	      { to: props.to, activeStyle: { color: "blueviolet" } },
	      props.children
	    )
	  );
	};
	
	exports.default = function (_ref) {
	  var children = _ref.children;
	  return _react2.default.createElement(
	    PageStyleForWholeSite,
	    null,
	    _react2.default.createElement(
	      Gutter,
	      null,
	      _react2.default.createElement(
	        StyledHeader,
	        null,
	        _react2.default.createElement(
	          StyledLink,
	          { to: "/", activeStyle: { color: "midnightblue" } },
	          _react2.default.createElement(
	            InlineHeader,
	            null,
	            "Penny Projects Ltd"
	          )
	        ),
	        _react2.default.createElement(
	          StyledList,
	          null,
	          _react2.default.createElement(
	            ListLink,
	            { to: "/blog" },
	            "Blog"
	          ),
	          _react2.default.createElement(
	            ListLink,
	            { to: "/talks" },
	            "Talks"
	          ),
	          _react2.default.createElement(
	            ListLink,
	            { to: "/training" },
	            "Training"
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _CardWrapper2.default,
	        null,
	        children()
	      ),
	      _react2.default.createElement(_footer2.default, null)
	    )
	  );
	};
	
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-9a342cd79be316b97380.js